<template>
	<div class="org_dept">
		<filterbar s_name="学院" @searchName="setSearchName" @school_search="setSchool_search"
			:getSchoolArray="getSchoolArray">
		</filterbar>
		<el-card shadow="hover" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<span>学院列表({{tableDataCount}})</span>
				<el-button style="float: right; padding: 3px 0" type="text" @click="dialogEdit = true">添加学院
				</el-button>
			</div>
			<el-table :data="showDate()">
				<el-table-column fixed type="index" width="50" align="center">
					<template slot-scope="scope">
						{{(page_current-1)*page_size+scope.$index+1}}
					</template>
				</el-table-column>
				<el-table-column prop="schoolName" label="学校名称" align="left">
					<template slot-scope="scope">
						{{showSchoolName(scope.row.schoolId)}}
					</template>
				</el-table-column>
				<el-table-column prop="name" label="学院名称" align="left"> </el-table-column>
				<el-table-column prop="firstLetter" label="首字母" align="left"> </el-table-column>
				<el-table-column prop="createTime" label="创建时间" align="center" width="160"></el-table-column>
				<el-table-column fixed="right" label="操作" align="center" width="200">
					<template slot-scope="scope">
						<el-button type="primary" icon="el-icon-edit" style="margin-right: 10px;" size="mini"
							@click="dialogEdit2_data = scope.row; dialogEdit2 = true">编辑</el-button>
						<el-popconfirm confirm-button-text='确认' cancel-button-text='取消' icon="el-icon-info"
							icon-color="red" title="确定删除吗？" @confirm="del(scope.row.id)">
							<el-button slot="reference" type="danger" icon="el-icon-delete" size="mini">
								删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="tableDataCount"
				class="pagination" @size-change="sizeChange" @current-change="currentChange">
			</el-pagination>
		</el-card>
		<dept-edit type="add" title="添加学院" :dialogVisible="dialogEdit" @before-close="dialogEdit=false;loadData()"
			:getSchoolArray="getSchoolArray" :getDeptArrayName="getDeptArray">
		</dept-edit>
		<dept-edit type="update" title="编辑学院" :dialogVisible="dialogEdit2" @before-close="dialogEdit2=false;loadData()"
			:obj="dialogEdit2_data" :getSchoolArray="getSchoolArray" :getDeptArrayName="getDeptArray">
		</dept-edit>
	</div>
</template>

<script>
	import deptEdit from './dept/edit.vue'
	import filterbar from '@/components/org-filterbar/filterBar1.vue'

	export default {
		name: 'dept',
		data() {
			return {
				page_size: 10,
				page_current: 1,
				tableDataCount: 0,
				search_name: '',
				search_school: '',
				dialogEdit: false,
				dialogEdit2: false,
				dialogEdit2_data: null,
				getDeptArray: [],
				getSchoolArray: []
			}
		},
		created() {
			this.loadData()
		},
		components: {
			deptEdit,
			filterbar
		},
		methods: {
			sizeChange(e) {
				this.page_size = e
			},
			currentChange(e) {
				this.page_current = e
			},
			showDate() {
				let _data = this.getDeptArray
					.filter(item => item.name && item.name.search(this.search_name) > -1 && item.schoolId.search(this
							.search_school) >
						-1)
				this.tableDataCount = _data.length
				return _data.slice((this.page_current - 1) * this.page_size, this.page_current * this.page_size)
			},
			del(id) {
				this.$http.get('api/Org/DelDept/' + id).then(res => {
					this.loadData()
				})
			},
			setSearchName(val) {
				this.search_name = val
			},
			setSchool_search(val) {
				this.search_school = val
			},
			showSchoolName(val) {
				let school = this.getSchoolArray.find(item => {
					return item.id == val
				})
				if (school) {
					return school.name
				}
				return ''
			},
			async loadData() {
				await this.$http.get('api/Org/GetSchools').then(res => {
					this.getSchoolArray = res.data.data
				})
				await this.$http.get('api/Org/GetDept/').then(res => {
					if (res.data.code == 1) {
						this.getDeptArray = []
						res.data.data.map(item => {
							this.getSchoolArray.map(item1 => {
								if (item1.id == item.schoolId) {
									this.getDeptArray.push(item)
								}
							})
						})
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						})
						this.getDeptArray = []
						return false
					}

				})
			}
		}
	}
</script>
<style lang="scss">
	.org_dept{
		.pagination {
			margin: 10px 0;
			text-align: center;
		}
	}
</style>
